import { Grid } from "@mui/material";
import { DetailPageHeader } from "@src/components/headers/DetailPageHeader";

import AddForm from "./Form";

export const AddPackage = () => {
    return (
        <>
            <DetailPageHeader />
            <Grid container spacing={4}>
                <Grid size={6}>
                    <AddForm />
                </Grid>
            </Grid>
        </>
    );
};
